/* Analytics hooks (06 l, CART-SPEC B10). SM.track(name, params) pushes GA4-style events to window.dataLayer and mirrors
   key events to gtag / Meta / TikTok / Klaviyo when those trackers exist. Every call is guarded: a missing or broken
   tracker never breaks the page or the cart. */
(() => {
  const SM = (window.SM = window.SM || {});
  const META = { view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout' };
  const TIKTOK = { view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout' };
  const ECOM = ['view_item', 'add_to_cart', 'remove_from_cart', 'view_cart', 'begin_checkout'];
  SM.track = function track(name, params) {
    params = params || {};
    const currency = params.currency || (SM.config && SM.config.analytics && SM.config.analytics.currency) || 'USD';
    try {
      window.dataLayer = window.dataLayer || [];
      if (ECOM.indexOf(name) > -1) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: name, ecommerce: Object.assign({ currency }, params) });
      } else {
        window.dataLayer.push(Object.assign({ event: name }, params));
      }
    } catch (e) {}
    try { if (typeof window.gtag === 'function' && ECOM.indexOf(name) > -1) window.gtag('event', name, Object.assign({ currency }, params)); } catch (e) {}
    try { if (typeof window.fbq === 'function' && META[name]) window.fbq('track', META[name], { currency, value: params.value }); } catch (e) {}
    try { if (window.ttq && typeof window.ttq.track === 'function' && TIKTOK[name]) window.ttq.track(TIKTOK[name], { currency, value: params.value }); } catch (e) {}
    try {
      if (name === 'add_to_cart' && window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', 'Added to Cart', { $value: params.value, AddedItemProductName: SM.config && SM.config.analytics && SM.config.analytics.itemName, AddedItemQuantity: params.items && params.items[0] && params.items[0].quantity, ItemVariant: params.items && params.items[0] && params.items[0].item_variant }]);
      }
    } catch (e) {}
  };
})();
